"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useState } from "react";
var regex = /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?/gm;
export var extractUrl = function(input) {
    regex.lastIndex = 0;
    var match = regex.exec(input);
    return match === null || match === void 0 ? void 0 : match.shift();
};
export var parseYoutubeId = function(input) {
    var url = extractUrl(input);
    if (!url) {
        return undefined;
    }
    var parts = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return parts[2] !== undefined ? parts[2].split(/[^0-9a-z_-]/i)[0] : undefined;
};
export default function VideoInline(param) {
    var target = param.target;
    var _useState = _sliced_to_array(useState(target), 2), videoTarget = _useState[0], setVideoTarget = _useState[1];
    useEffect(function() {
        if (target.toLowerCase().includes("youtube.com/watch") || target.toLowerCase().includes("youtu.be")) {
            var id = parseYoutubeId(target);
            if (id) {
                var baseUrl = "https://www.youtube.com/embed/".concat(id);
                if (target.includes("autoplay=1")) {
                    setVideoTarget(baseUrl.replace("autoplay=1", "autoplay=0"));
                } else {
                    setVideoTarget("".concat(baseUrl, "?autoplay=0"));
                }
            }
        } else if (target.toLowerCase().includes("wistia")) {
            var wistiaBase = "https://fast.wistia.net/embed/iframe/";
            // Extract video ID from URL (assuming it's in the format)
            var match = target.match(/wistia.*(?:iframe|medias)\/([a-z0-9]+)/i);
            var id1 = match ? match[1] : null;
            if (id1) {
                // Check if target already has query parameters
                var hasQuery = target.includes("?");
                var autoPlayParam = hasQuery ? "&autoPlay=false" : "?autoPlay=false";
                setVideoTarget("".concat(wistiaBase).concat(id1).concat(autoPlayParam));
            } else {
                // Fallback: use original target but ensure no autoplay
                var hasQuery1 = target.includes("?");
                setVideoTarget("".concat(target).concat(hasQuery1 ? "&" : "?", "autoPlay=false"));
            }
        }
    }, [
        target
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-full max-w-3xl"
    }, /*#__PURE__*/ React.createElement("iframe", {
        style: {
            width: "100%",
            aspectRatio: "717 / 403"
        },
        src: videoTarget.replace("autoplay=1", "autoplay=0&autoPlay=false"),
        title: "YouTube video player",
        allow: "encrypted-media",
        allowFullScreen: true,
        className: "max-w-full"
    }));
}
